export { default } from './AspectRatioContent';
